module.exports = __webpack_public_path__ + "media/Tropic_Of_Capricorn.1058b852.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/labels/Tropic_Of_Capricorn.png
// module id = 1121
// module chunks = 0